import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminEndpoints } from "../services/api";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import { image } from "../data/image";

const { LOGIN_API_FOR_ADMIN, API_FOR_LOGIN } = adminEndpoints;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(API_FOR_LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("Login Successful:", data);
        if (data.token) {
          localStorage.setItem("token", data.token);
        }
        toast.success("Login successful! 🎉");
        navigate("/admin/blog/manage-blog");
      } else {
        console.error("Login Failed:", data);
        setError(data.message || "Invalid email or password.");
        toast.error(data.message || "Invalid credentials ❌");
      }
    } catch (error) {
      console.error("Network Error:", error);
      setError("Network error. Please check your connection.");
      toast.error("Network error. Please check your connection. ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center w-full min-h-screen bg-[#0F172A]">
      {/* Login Card */}
      <motion.div
        className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Law Firm Logo */}
        <img src={image.logo} alt="Law Firm Logo" className="w-20 mx-auto mb-4" />

        <h2 className="text-3xl font-bold text-[#0F172A] mb-6">Admin Login</h2>

        {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

        {/* Login Form */}
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full p-3 bg-gray-100 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C9A227] outline-none"
            disabled={loading}
          />

          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full p-3 bg-gray-100 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C9A227] outline-none"
            disabled={loading}
          />

          {/* Submit Button with Loader */}
          <button
            type="submit"
            className="w-full py-3 bg-[#C9A227] text-[#0F172A] font-semibold rounded-lg shadow-md hover:bg-[#B79527] transition-all duration-300 flex items-center justify-center"
            disabled={loading}
          >
            {loading ? (
              <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
            ) : (
              "Login"
            )}
          </button>
        </form>

        
      </motion.div>
    </div>
  );
}
